import { useEffect } from 'react'

export default function useClickOutside(ref, callback) {
    useEffect(() => {
        const handleClickOutside = (evt) => {
            const cur = ref.current

            if (!cur || cur.contains(evt.target)) return

            callback()
        }

        document.addEventListener('click', handleClickOutside)
        document.addEventListener('touchstart', handleClickOutside)

        return () => {
            document.removeEventListener('click', handleClickOutside)
            document.removeEventListener('touchstart', handleClickOutside)
        }
    }, [ref, callback])
}